import apiClient from './client';

export const getXPStatus = () =>
  apiClient.get('/api/xp/status').then(res => res.data);

export const getXPHistory = (limit = 50, source = null) => {
  const params = { limit };
  if (source) params.source = source;
  return apiClient.get('/api/xp/history', { params }).then(res => res.data);
};
